let template = () => `
  <div id="events-heading">Event Log</div>
  <ol id="events"></ol>
`;
export default template;
